import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
import VueAnalytics from 'vue-analytics';
import vueObserveVisibility from 'vue-observe-visibility';
import Buefy, { ToastProgrammatic as Toast } from 'buefy';

import moment from 'moment-timezone';

import App from './App.vue';
import router from './router';
import store from './store';

import filters from './filters';

require('any-resize-event');

Vue.config.productionTip = false;

filters(Vue);

Vue.use(vueObserveVisibility);
Vue.use(Buefy, { defaultDateParser: value => moment(value, 'DD/MM/YYYY').toDate() });
Vue.use(VueApexCharts);
Vue.use(VueAnalytics, {
  id: process.env.VUE_APP_GA_ID,
  router,
});

Vue.component('ApexChart', VueApexCharts);

Vue.mixin({
  methods: {
    $danger({ duration = 5000, position = 'is-top', message }) {
      Toast.open({
        duration,
        message,
        position,
        type: 'is-danger',
      });
    },
    $warning({ duration = 5000, position = 'is-top', message }) {
      Toast.open({
        duration,
        message,
        position,
        type: 'is-warning',
      });
    },
    $success({ duration = 5000, position = 'is-top', message }) {
      Toast.open({
        duration,
        message,
        position,
        type: 'is-success',
      });
    },
    $modalForm(options) {
      /**
       * @param {boolean} show if modal is show or hide
       * @param {string} component name of child component inside modal ej: 'NewCustomer'
       * @param {string} title modal title text
       * @param {string} btnSave button create | save text default: 'Crear'
       * @param {string} btnClose button close text default: 'Cerrar'
       * @param {fn} saved return function when form saved
       * @param {fn} closed return function when modal closed
       */
      this.$store.commit('modalForm/setValues', options);
    },
  },
});

const render = h => h(App);

new Vue({ router, store, render }).$mount('#app');
